import { CincClientType } from "../../enums/CincClientType";
import { Company } from "../../enums/Company";
import { RgClientType } from "../../enums/RgClientType";

export class AdAccountCreationRequest{
    public ClientFullName!: string;
    public DomainName!: string;
    public States!: string[];
    public Brokerage!: string;
    public TimeZone!: string;
    public Company!: Company;
    public CincClientType!: CincClientType;
    public RgClientType!: RgClientType;
    public PageId!: string;
}